import { render, staticRenderFns } from "./OrderCustomer.vue?vue&type=template&id=7f17f6fa&scoped=true&"
import script from "./OrderCustomer.vue?vue&type=script&lang=js&"
export * from "./OrderCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f17f6fa",
  null
  
)

export default component.exports